import axios from 'axios'
import qs from "qs"
import { clone, removeEmpty } from '@/util/libUtil.js'
import readError from '../util.js'


const state = () => ({
    isOpenDialog: false,
    isEditableForm: false,
    formType: '',
    editingId: '',
    IsActive: false,
    Name: '',
    Operator: '',
    Duration: '',
    Duration_Unit: '',
    Amount: '',
    Amount_Unit: '',
    promotionManagement: {
        promotions: [],
        totalEntries: 0,
        isLoading: false,
        page: 1,
        params: {},
        default: 0
    },
    tariffsDropDown: [],
    SelectedTariffs: [],
    paths: {
        tariffDropDownPath: '/api/servicios/tariff-adicionales-sva-drop-down/',
        promotionsPath: '/api/servicios/promociones/',
    }
})

const mutations = {
    promotionManagementPage: (state, val) => {
        state.promotionManagement.page = val;
    },
    promotionManagementTarrifs: (state, val) => {
        state.promotionManagement.promotions = clone(val);
    },
    promotionManagementParams(state, val) {
        state.promotionManagement.params = val
    },
    promotionManagementIsLoading(state, val) {
        state.promotionManagement.isLoading = val
    },
    promotionManagement(state, val) {
        state.promotionManagement.totalEntries = val.count
        state.promotionManagement.promotions = val.results
    },
    isOpenDialog: (state, val) => {
        state.isOpenDialog = val;
    },
    isEditableForm: (state, val) => {
        state.isEditableForm = val;
    },
    formType: (state, val) => {
        state.formType = val;
    },
    editingId: (state, val) => {
        state.editingId = val;
    },
    Name: (state, val) => {
        state.Name = val
    },
    Operator: (state, val) => {
        state.Operator = val
    },
    Duration: (state, val) => {
        state.Duration = val
    },
    Duration_Unit: (state, val) => {
        state.Duration_Unit = val
    },
    Amount: (state, val) => {
        state.Amount = val
    },
    Amount_Unit: (state, val) => {
        state.Amount_Unit = val
    },
    IsActive: (state, val) => {
        state.IsActive = val
    },
    // promotions: (state, val) => {
    //     state.promotionManagement.promotions = clone(val)
    // },
    tariffsDropDown: (state, val) => {
        state.tariffsDropDown = clone(val)
    },
    SelectedTariffs: (state, val) => {
        state.SelectedTariffs = clone(val)
    },
}

const actions = {
    async updatePromotionManagementParams({ commit, state }, params) {
        let newParams = { ...state.promotionManagement.params, ...params }
        newParams = removeEmpty(newParams) // eliminate nulls
        commit('promotionManagementParams', newParams)
    },
    async getPromotions({ dispatch, getters, rootGetters, state, commit }) {
        try {
            commit('promotionManagementIsLoading', true)
            commit('ManagementBase/loadingItems', true, { root: true })
            let params = clone(state.promotionManagement.params);
            
            if(!'itemsPerPage' in params || !params['itemsPerPage']){
                params['itemsPerPage'] = rootGetters['ManagementBase/itemsPerPage']
            }

            let resp = await axios.get(getters.getEndpointFromPath(state.paths.promotionsPath), {
                params: params,
                paramsSerializer: params => {
                    return qs.stringify(params, { arrayFormat: 'brackets', skipNulls: true })
                },
            })
            commit('promotionManagement', resp.data)
            commit('promotionManagementIsLoading', false)
            commit('ManagementBase/loadingItems', false, { root: true })

            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Promociones cargadas correctamente'
            }, { root: true })
        } catch (error){
            let read = readError.readError(error)

            if('detail' in read && read.detail == 'Página inválida.'){
                dispatch('updatePromotionManagementParams', { page: 1 })
                dispatch('getPromotions')
            }else{
                dispatch('util/showStatusSnackBar', {
                    statusType: 'error',
                    message: 'No se pudo cargar el contenido de Promocioón'
                }, { root: true })
            }
        }
    },
    async getTariffDropDown({ dispatch, getters, state, commit }) {
        try {
            // commit('ManagementBase/loadingItems', true, {root: true})
            let resp = await axios.get(getters.getEndpointFromPath(state.paths.tariffDropDownPath))
            commit('tariffsDropDown', resp.data)
            // commit('ManagementBase/loadingItems', false, {root: true})
        }
        catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'No se pudo cargar el contenido'
            }, { root: true })
        }
    },
    async delete({ state, dispatch, getters }, item) {
        try {
            await axios.delete(getters.getEndpointFromPath(state.paths.promotionsPath) + item.id + '/')
            dispatch('getPromotions')
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Entrada borrada'
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'No se pudo eliminar la entrada'
            }, { root: true })
        }
    },
    async addPromotion({ state, getters, dispatch }) {
        let promotion = {
            'name': state.Name,
            'is_active': state.IsActive,
            'duration': state.Duration,
            'duration_unit': state.Duration_Unit,
            'amount': state.Amount,
            'amount_unit': state.Amount_Unit,
            'operator': state.Operator,
            'tariffs': state.SelectedTariffs

        }

        // try {
        await axios.post(getters.getEndpointFromPath(state.paths.promotionsPath), promotion)
        dispatch('getPromotions')
        dispatch('util/showStatusSnackBar', {
            statusType: 'success',
            message: 'Tarifa añadida correctamente',
        }, { root: true })
        // } catch {
        //     dispatch('util/showStatusSnackBar', {
        //         statusType: 'error',
        //         message: 'Error al añadir promocion',
        //     }, {root: true})
        // }
    },
    async editPromotion({ state, getters, dispatch }) {
        let promotion = {
            'name': state.Name,
            'is_active': state.IsActive,
            'duration': state.Duration,
            'duration_unit': state.Duration_Unit,
            'amount': state.Amount,
            'amount_unit': state.Amount_Unit,
            'operator': state.Operator,
            'tariffs': state.SelectedTariffs
        }

        try {
            await axios.put(getters.getEndpointFromPath(state.paths.promotionsPath) + state.editingId + '/', promotion)
            dispatch('getPromotions')
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Tarifa añadida correctamente',
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Error al añadir promocion',
            }, { root: true })
        }
    },
}

const getters = {
    getEndpointFromPath: (_state, _unused, rootState) => endpoint => (
        rootState.general.host + endpoint
    )
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}